module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTI4IiBoZWlnaHQ9IjEyOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNzMuMTM3IDI5LjA4aC05LjIwOSAyOS43TDYzLjg4Ni4wOTMgMzQuMzczIDI5LjA4aDIwLjQ5djI3LjAzNUgyNy4yMzh2MTcuOTQ4aDI3LjYyNXYyNy4xMzNoMTguMjc0Vjc0LjA2M2gyNy40MVY1Ni4xMTVoLTI3LjQxVjI5LjA4em0tOS4yNDUgOTguODI3bDI3LjUxOC0yNi43MTFIMzYuNTlsMjcuMzAyIDI2Ljcxek0uMDQyIDY0Ljk4MmwyNy4xOTYgMjcuMDI5VjM4LjE2N0wuMDQyIDY0Ljk4MnptMTAwLjUwNS0yNi44MTVWOTIuMDFsMjcuNDEtMjcuMDI5LTI3LjQxLTI2LjgxNXoiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/drag.svg
// module id = 1724
// module chunks = 1